var _rect, _path, _rect2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCheckboxInputDisabled(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 15,
    height: 15,
    rx: 3.5,
    fill: "#7E858F"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.207 4.79303C12.3945 4.98056 12.4998 5.23487 12.4998 5.50003C12.4998 5.76519 12.3945 6.0195 12.207 6.20703L7.207 11.207C7.01947 11.3945 6.76516 11.4998 6.5 11.4998C6.23483 11.4998 5.98052 11.3945 5.793 11.207L3.793 9.20703C3.61084 9.01843 3.51004 8.76583 3.51232 8.50363C3.5146 8.24143 3.61977 7.99062 3.80518 7.80521C3.99058 7.6198 4.2414 7.51463 4.50359 7.51236C4.76579 7.51008 5.01839 7.61087 5.20699 7.79303L6.5 9.08603L10.793 4.79303C10.9805 4.60556 11.2348 4.50024 11.5 4.50024C11.7652 4.50024 12.0195 4.60556 12.207 4.79303Z",
    fill: "#2B2D31"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 15,
    height: 15,
    rx: 3.5,
    stroke: "#7E858F"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckboxInputDisabled);
export default __webpack_public_path__ + "static/media/checkbox-input-disabled.cd60cb10764f951068dd1dc539bf41c8.svg";
export { ForwardRef as ReactComponent };